app.slick = {

    settings: {
    },

    init: function() {
		
		$('.slick-cards').slick({
			infinite: false,
			slidesToShow: 3,
			slidesToScroll: 3,
			dots: true,
			arrows: false,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					}
				},
				{
					breakpoint: 680,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					}
				},
			]
		});

    }
};